<template>
  <div class="has-background-white panier-component columns mt-15">
    <div class="column is-narrow ml-40 mr-12">
      <img v-if="reseau.urlPhoto"
          class="image tailleImage"
          :src="reseau.urlPhoto">
      <img v-else class="image tailleImage"
        src="@/assets/default-placeholder.png"/>
      <p class="has-text-weight-bold has-text-dark is-size-6 champReseau">
        Réseau : <span>{{reseau.libelle}}</span>
      </p>
      <p>Nb de faces :
        {{reseau.nbFaces}}
      </p>
      <b-modal v-model="isComponentDetailReseaux"
                has-modal-card
                class="modal">
              <info-window-reseaux :reseau ="reseau"/>
      </b-modal>
      <a class="plusInfo" @click="isComponentDetailReseaux = !isComponentDetailReseaux">
        Plus d'informations sur le réseau
      </a>
    </div>
    <div class="column columns">
      <div class="column is-8 columns is-paddingless is-marginless">
        <div>
          <div class="column columns is-marginless is-paddingless is-multiline">
            <div class="column p-5px is-one-fifth">
              <b-field label="Tarif HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency v-model="reseau.extensionOpportunite.tarifBrut"
                                isNumber="true"
                                :disabled="disabled"
                                @input="changeTarifBrut"/>
              </b-field>
            </div>
            <div class="column p-5px is-one-fifth">
              <b-field label="/an , /mois…" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-input v-model="reseau.extensionOpportunite.tarifInformation"
                                    :disabled="disabled"/>
              </b-field>
            </div>
            <div class="column p-5px is-one-fifth">
              <b-field label="Remise" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-field>
                  <input-currency v-model="reseau.extensionOpportunite.remise"
                                  isNumber="true"
                                  @input="onRemiseChange"
                                  :disabled="disabled"/>
                  <b-select
                    v-model="reseau.extensionOpportunite.typeDeRemise"
                    placeholder="0"
                    :disabled="disabled">
                    <option :value="0">%-</option>
                    <option :value="1">€</option>
                  </b-select>
                </b-field>
              </b-field>
            </div>
            <div class="column p-5px is-one-fifth">
              <b-field label="Tarif Net HT" class="mb-0" custom-class="mb-0 label-color" expanded>
                <input-currency
                  :value="reseau.extensionOpportunite.tarifNet"
                  isNumber="true"
                  :disabled="disabled"
                  @input="changeTarifNet($event, true)">
                </input-currency>
              </b-field>
            </div>
            <div class="column p-5px is-one-fifth">
              <b-field label="Durée" class="mb-0" custom-class="mb-0 label-color" expanded>
                <b-input
                  v-model="reseau.extensionOpportunite.duree"
                  placeholder=""
                  :disabled="disabled"></b-input>
              </b-field>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 p-5px">
                <div class="control">
                  <label class="subtitle">Tarif de pose HT</label>
                  <input-currency v-model="reseau.extensionOpportunite.tarifDePose"
                                  isNumber="true"
                                  :disabled="disabled">
                  </input-currency>
                </div>
              </div>
              <div class="column is-12 p-5px">
                <div class="control">
                  <label class="subtitle">Taxes municipales / TLPE</label>
                  <input-currency v-model="reseau.extensionOpportunite.taxeMunicipale"
                                  :disabled="disabled">
                  </input-currency>
                </div>
                Montant TLPE pour la 1ère année
              </div>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 p-5px">
                <div class="control">
                  <label class="subtitle">Frais technique HT</label>
                  <input-currency v-model="reseau.extensionOpportunite.fraisTechnique"
                                  isNumber="true"
                                  :disabled="disabled">
                  </input-currency>
                </div>
              </div>
              <div class="column is-12 p-5px">
                <div class="control">
                  <label class="subtitle">Date de disponibilité</label>
                  <b-datepicker
                    icon="calendar-today"
                    position="is-top-right"
                    :readonly="false"
                    v-model="reseau.extensionOpportunite.date"
                    :disabled="disabled"/>
                </div>
              </div>
            </div>
            <div class="column is-4 p-5px">
              <div class="column is-12 p-5px">
                <b-field label="Commentaire" custom-class="mb-0 label-color">
                  <b-input
                    type="textarea"
                    rows="2"
                    v-model="reseau.extensionOpportunite.commentaire"
                    :disabled="disabled"/>
                </b-field>
              </div>
              <div class="column is-12 p-5px" v-if="reseau.extensionOpportunite.tournante">
                <b-field label="Instructions d'affichage" custom-class="mb-0 label-color">
                  <b-input
                    type="textarea"
                    rows="2"
                    v-model="reseau.extensionOpportunite.instructionsAffichage"
                    :disabled="disabled"/>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4 columns is-multiline">
        <div class="column is-6 p-5px">
          <b-switch v-model="reseau.extensionOpportunite.tournante"
                  @input="resetInstructionAffichage"
                  type="is-primary"
                  :disabled="disabled">
            LC Tournante
          </b-switch>
        </div>
        <div class="column p-5px">
          <div class="is-flex flex-align-center-justify-end p-5px ">
            <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
              {{reseau.prixTotal}} €
            </p>
            <a @click="suppressionPanneau">
              <b-icon icon="delete-forever" type="is-danger"/>
            </a>
          </div>
        </div>
        <div class="column is-12 is-multiline has-background-color-background p-5px">
          <span class="mb-0 label-color has-text-weight-bold p-5px">Editions</span>
          <div class="column is-12 p-5px">
            <article class="media media-align-center">
              <div class="media-left">
                <button
                  class="button"
                  v-bind:class="[reseau.extensionOpportunite.masquerRemiseEdition ?
                    'is-primary' : 'is-grey']"
                  @click.prevent="$refs.checkBoxMasquerRemiseEdition.click()">
                  <b-icon
                    icon="percent"
                    :type="reseau.extensionOpportunite.masquerRemiseEdition ?
                      'is-white' : 'is-grey'"></b-icon>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold is-inline">
                  Afficher la remise sur l’édition
                </div>
                <input
                  type="checkbox"
                  v-model="reseau.extensionOpportunite.masquerRemiseEdition"
                  :disabled="disabled"
                  id="checkbox"
                  class="is-invisible is-inline"
                  ref="checkBoxMasquerRemiseEdition">
              </div>
            </article>
          </div>
          <div class="column is-12 p-5px">
            <article class="media">
              <div class="media-left">
                <button class="button"
                      v-bind:class="[reseau.extensionOpportunite.masquerFaceEdition ?
                      'is-primary' : 'is-grey']"
                      :disabled="disabled"
                      @click="reseau.extensionOpportunite.masquerFaceEdition =
                      !reseau.extensionOpportunite.masquerFaceEdition">
                      <b-icon icon="eye-off" :type="reseau.extensionOpportunite.masquerFaceEdition ?
                            'is-white' : 'is-grey'"/>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold">
                  Masquer les faces sur l'édition
                </div>
              </div>
            </article>
          </div>
          <div class="column is-12 p-5px">
            <article class="media">
              <div class="media-left">
                <button
                  class="button"
                  :disabled="disabled"
                  :class="reseau.extensionOpportunite.visualiserCarteEdition ?
                  'is-primary' : 'is-grey'"
                  @click.prevent="$refs.checkBoxVisuCartoReseauLc.click()">
                  <b-icon icon="google-maps"/>
                </button>
              </div>
              <div class="media-content is-paddingless">
                <div class="content has-text-weight-semibold">
                  Afficher la cartographie
                </div>
                <input
                  type="checkbox"
                  v-model="reseau.extensionOpportunite.visualiserCarteEdition"
                  :disabled="disabled"
                  id="checkbox"
                  class="is-invisible"
                  ref="checkBoxVisuCartoReseauLc">
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import { calculTarifNet } from '@/services/calcul/calculTarif';
import { calculRemiseVenteRxLc } from '@/services/calcul/calculRemise';
import { RESEAU_LC } from '@/configuration/typesProduits';
import infoWindowReseaux from './infoWindowReseaux';

const Panier = createNamespacedHelpers('panier');
const user = createNamespacedHelpers('user');

export default {
  name: 'ventes-reseau-lc',
  props: ['reseau', 'disabled'],
  data() {
    return {
      isComponentDetailReseaux: false,
    };
  },
  components: {
    inputCurrency,
    infoWindowReseaux,
  },
  watch: {
    'reseau.extensionOpportunite.typeDeRemise': {
      handler() {
        this.changeTarifNet();
      },
      immediate: false,
    },
    'reseau.extensionOpportunite.tarifBrut': {
      handler(value) {
        this.changeTarifNet(value);
      },
      immediate: false,
    },
  },
  computed: {
    ...user.mapGetters({
      isAffichageFaceEditionDefault: 'isAffichageFaceEditionDefault',
    }),
  },
  methods: {
    ...Panier.mapMutations({
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_RESEAU_LC,
    }),
    suppressionPanneau() {
      this.setRemoveProduit(this.reseau);
    },
    resetInstructionAffichage() {
      if (!this.reseau.extensionOpportunite.tournante) {
        this.reseau.extensionOpportunite.instructionsAffichage = null;
      }
    },
    changeTarifNet(value, champTarifNet = false) {
      if (champTarifNet === true && this.reseau.extensionOpportunite.tarifBrut) {
        calculRemiseVenteRxLc(this.reseau, value);
        return;
      }
      calculTarifNet(this.reseau, value, RESEAU_LC);
    },
    changeTarifBrut(e) {
      this.reseau.extensionOpportunite.tarifBrut = e;
    },
    onRemiseChange(value) {
      let remise = value;
      if (!value) {
        remise = 0;
      }
      this.reseau.extensionOpportunite.remise = remise;
      this.changeTarifNet();
    },
  },
  mounted() {
    if (this.reseau.extensionOpportunite.masquerFaceEdition === null) {
      this.reseau.extensionOpportunite.masquerFaceEdition = !this.isAffichageFaceEditionDefault;
    }
  },
};
</script>

<style scoped>
  .inputFacesLc {
    padding-bottom:10px
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxLc.vue